document.querySelectorAll('.benefit-item').forEach((cta) => {
    cta.addEventListener('click', () => {
        // Handling Tooltip click event
        if (cta.querySelector('.benefit-item__tooltip').classList.contains('active')) {
            cta.querySelector('.benefit-item__tooltip').classList.remove('active');
        } else {
            document.querySelectorAll('.benefit-item__tooltip').forEach((otherTooltip) => {
                otherTooltip.classList.remove('active');
            });
            cta.querySelector('.benefit-item__tooltip').classList.toggle('active');
        }
    });

    // Closing Tooltip when clicking outside
    document.addEventListener('click', (event) => {
        if (!cta.contains(event.target)) {
            cta.querySelector('.benefit-item__tooltip').classList.remove('active');
        }
    });
});
